import React, { useEffect, useRef, useState } from "react";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useShowAlert } from "../../../context/AlertContext";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { AddIcon, CloseIcon } from "../../../constants/Icons";

const AdvanceModal = ({ jobcardId, onClose, onAdvanceAdded }) => {
  const showAlert = useShowAlert();
  const [amount, setAmount] = useState("");
  const [paymentmode, setPaymentMode] = useState("");

  const paymentRef = useRef(); // 👈 For focusing Payment Mode
  const addButtonRef = useRef(); // 👈 For triggering Add

  const handleAdd = async () => {
    if (!amount || isNaN(amount))
      return showAlert("Please enter a valid amount", "warning");
    if (!paymentmode)
      return showAlert("Please select a payment mode", "warning");

    try {
      const payload = {
        advancePaid: CurrencyConverter.toSubunit(amount || 0, "INR"),
        paymentMode: paymentmode,
      };

      const response = await AxiosInstance.patch(
        `module/jobcard/advancepaid/${jobcardId}`,
        payload
      );

      if (response?.data?.status) {
        const updatedJobcard = response.data.results;
        const newTotal = Number(updatedJobcard.totalAdvancePaid) || 0;
        const lastAdvance = Number(amount) || 0;

        onAdvanceAdded(lastAdvance, newTotal);
        onClose();
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    window.addEventListener("keydown", handleEsc);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onClose]);

  return (
    <>
      <div className="modal-backdrop show"></div>
      <div
        className="modal show"
        tabIndex="-1"
        role="dialog"
        style={{ display: "block" }}
      >
        <div className="modal-dialog modal-sm modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add Advance</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
              ></button>
            </div>

            <div className="modal-body">
              {/* AMOUNT FIELD */}
              <label className="form-label">Amount</label>
              <input
                className="form-control"
                placeholder="Enter amount"
                value={amount}
                autoFocus
                onChange={(e) => {
                  const val = e.target.value;
                  if (/^\d*\.?\d*$/.test(val)) {
                    setAmount(val);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    paymentRef.current?.focus();
                  }
                }}
              />

              {/* PAYMENT MODE FIELD */}
              <div className="col-md-12 mt-3">
                <label htmlFor="paymentmode" className="form-label">
                  Payment Mode
                </label>
                <select
                  name="paymentmode"
                  className="form-select"
                  ref={paymentRef}
                  value={paymentmode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      addButtonRef.current?.click(); // 👈 Trigger Add button
                    }
                  }}
                >
                  <option value="">Select</option>
                  <option value="CASH">Cash</option>
                  <option value="CARD">Card</option>
                  <option value="ONLINE">Online</option>
                  <option value="UPI">UPI</option>
                </select>
              </div>
            </div>

            {/* FOOTER BUTTONS */}
            <div className="modal-footer d-block">
              <button
                className="btn btn-outline-secondary text-left"
                onClick={onClose}
              >
                <CloseIcon iClass={"fs-15"}/> Cancel
              </button>
              <button
                ref={addButtonRef}
                className="btn text-right btn-label-jobcard"
                onClick={handleAdd}
              >
                <AddIcon/> Add
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdvanceModal;
